import { useState } from "react"
import { FormField, Text, TextField } from "@smooth/design-system-components"

/** 入力欄の文字列をノード ID の並びにする（空白・カンマ・読点・矢印で区切る） */
export const parseExpectedPath = (text: string) =>
  text
    .split(/[\s,、→>]+/)
    .map((node) => node.trim())
    .filter(Boolean)

const sameNodes = (a: string[], b: string[]) =>
  a.length === b.length && a.every((node, index) => node === b[index])

/** 期待する道筋の読み取り表示 */
export function ExpectedPathText({ path }: { path: string[] | undefined }) {
  return <Text size="sm">{path?.length ? path.join(" → ") : "未設定"}</Text>
}

/**
 * 期待する道筋の編集。判断ノード ID を順に並べる（任意・AI には渡さない）。プロンプトの比較で AI の判断記録の道筋と
 * 先頭から比べ、最初にずれた歩を出す。途中までだけ書いてもよい（書いた長さまで比べる）
 */
export function ExpectedPathField({
  path,
  onChange,
}: {
  path: string[] | undefined
  onChange: (path: string[] | undefined) => void
}) {
  const nodes = path ?? []
  const joined = nodes.join(" ")
  const [text, setText] = useState(joined)
  // 入力中の区切りの空白を消さないよう、外から並びが変わったとき（編集を取り消した等）だけ入力欄を合わせる
  const [synced, setSynced] = useState(joined)
  if (joined !== synced) {
    setSynced(joined)
    if (!sameNodes(parseExpectedPath(text), nodes)) setText(joined)
  }

  return (
    <FormField label="期待する道筋">
      <TextField
        value={text}
        placeholder="例：COMPLIANCE R04 A01 A02"
        onChange={(e) => {
          setText(e.target.value)
          const parsed = parseExpectedPath(e.target.value)
          // 空にしたら項目ごと外す（期待する道筋を持たないケースと同じ形にする）
          onChange(parsed.length ? parsed : undefined)
        }}
      />
    </FormField>
  )
}
